import React from 'react';
import Text from '@ingka/text';
import SSRIcon from '@ingka/ssr-icon';
import informationCircle from '@ingka/ssr-icon/paths/information-circle';
import styled from 'styled-components';
import useTranslation from '../hooks/useTranslation';

const StyledText = styled(Text)`
  &&& {
    margin-bottom: 35px;
  }
`;

export const LoginPrompt = (): JSX.Element => {
  const { t } = useTranslation();
  return (
    <StyledText tagName="p" textStyle="Body.L">
      <SSRIcon paths={informationCircle} />
      {t('pages.start.loginPrompt')}
    </StyledText>
  );
};
